export default __webpack_public_path__ + "static/media/ic_bnb_24.a8f56d16.svg";